import type { CSSProperties } from 'react';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  style?: CSSProperties;
}

export function Skeleton({ width = '100%', height = 12, radius = 'var(--r-sm)', style }: SkeletonProps) {
  return (
    <span
      className="tv-skeleton"
      style={{ display: 'block', width, height, borderRadius: radius, ...style }}
    />
  );
}
